export const GoogleMapsDirections = {
  URL: 'https://www.google.com/maps/dir/',
  API_VERSION: '1',
  VENUE_SEPARATOR: ', ',
}
